import cmp from '../../lib/cmp';
import { smap } from '../../lib/utils';
import './sm-landing-appstore-app-1-supports.less';
import { isRtl } from '../../lib/document-dir-utils';



const supportsItem = ({ icon, title, text }) => `
  <div class="sm-landing-appstore-app-1-supports__item">
    <img class="sm-landing-appstore-app-1-supports__item-image${isRtl() ? '-rtl' : ''}" src="${icon.url}">
    <div class="sm-landing-appstore-app-1-supports__item-content">
      <div class="sm-landing-appstore-app-1-supports__item-content-title">${title}</div>
      ${text ? `<div class="sm-landing-appstore-app-1-supports__item-content-text">${text}</div>` : ''}
    </div>
  </div>
`;

const template = ($cmp, { supports }) => `
  <div class="sm-landing-appstore-app-1-supports">
    <div class="sm-landing-appstore-app-1-supports__h">${__('sm@_supports')}</div>
    <div class="sm-landing-appstore-app-1-supports__list-wr">
      <div class="sm-landing-appstore-app-1-supports__list">
       ${smap(supports, supportsItem)}
      </div>
    </div>
  </div>
`;



export default cmp(null, template);



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-supports/sm-landing-appstore-app-1-supports.js